export default {
  '角色列表':'角色列表',
  '角色名模糊搜索':'角色名模糊搜索',
  '新增角色':'新增角色',
  '管理成员':'管理成员',
  '角色名称':'角色名称',
  '角色备注':'角色备注',
  '身份':'身份',
  '成员数量':'成员数量',
  '确认要删除该角色：{roleName}？':'确认要删除该角色：{roleName}？',
  '角色类型':'角色类型',
  '请输入角色名称,仅支持中英文、数字':'请输入角色名称,仅支持中英文、数字',
  '功能权限':'功能权限',
  '移动端':'移动端',
  '编辑角色':'编辑角色',
  '角色名称仅支持中英文、数字':'角色名称仅支持中英文、数字',
  '成功！':'成功！',
  '新增成员':'新增成员',
  '取消全部选中':'取消全部选中',
  '是否确认批量移除{length}名成员？':'是否确认批量移除{length}名成员？',
  '批量移除成功':'批量移除成功',
  '是否确认移除成员{accountName}？':'是否确认移除成员{accountName}？',
  '移除成功':'移除成功',
  '请输入用户名称':'请输入用户名称',
  '新增成员成功!':'新增成员成功!',
  '已选中{selectedCount}人':'已选中{selectedCount}人',

  //25-8-4
  '操作成功':'操作成功',
}